// @ts-expect-error - @sentry/react is installed in individual apps, not in shared
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'

import { useAuthStore } from '../store/auth'

type UserWithOrgFallback = {
  id?: string
  email?: string
  full_name?: string
  organization_id?: string
  organization_name?: string
  organization_type?: string
  organization?: {
    id?: string
    name?: string
    type?: string
  }
}

export function SentryUserContext() {
  const user = useAuthStore((state) => state.user) as UserWithOrgFallback | null
  const activeOrganizationId = useAuthStore((state) => state.activeOrganizationId)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  useEffect(() => {
    if (!isAuthenticated || !user) {
      Sentry.setUser(null)
      Sentry.setTag('organization_id', 'anonymous')
      Sentry.setTag('organization_type', 'anonymous')
      Sentry.setContext('organization', null)
      return
    }

    const organizationId = activeOrganizationId || user.organization?.id || user.organization_id
    const organizationName = user.organization?.name || user.organization_name
    const organizationType = user.organization?.type || user.organization_type

    Sentry.setUser({
      id: user.id,
      email: user.email,
      username: user.full_name,
    })

    Sentry.setTag('organization_id', organizationId || 'unknown')
    Sentry.setTag('organization_type', organizationType || 'unknown')
    Sentry.setContext('organization', {
      id: organizationId || null,
      name: organizationName || null,
      type: organizationType || null,
    })
  }, [activeOrganizationId, isAuthenticated, user])

  return null
}
